module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-body extratoff"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.loading.carregando) ? _c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(0)]) : _c('div', {
    staticClass: "col-md-12"
  }, [(_vm.acertos.length === 0) ? _c('div', {
    staticClass: "col-md-12"
  }, [(_vm.acertoAcao === '') ? _c('p', {
    staticClass: "bg-info"
  }, [_vm._v("\n          Não há registros de acertos/devolução no Contas a Pagar nem a Receber no Sapiens\n        ")]) : _c('p', {
    staticClass: "bg-danger"
  }, [_vm._v(_vm._s(_vm.acertoAcao))])]) : _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.processando),
      expression: "loading.processando"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "table table-condensed"
  }, [_vm._l((_vm._.groupBy(_vm.acertos, 'origem')), function(recurso, codigoRecurso) {
    return [_c('thead', [_c('tr', {
      staticClass: "cabecalho"
    }, [_c('th', {
      attrs: {
        "colspan": "2"
      }
    }, [_vm._v("Acertos por conta financeira em Recursos " + _vm._s(codigoRecurso === 1 ? 'da Fundação BB' : 'de Parceiro Estratégico'))]), _vm._v(" "), _c('th', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          inertia: true,
          arrow: true,
          animation: 'perspective',
          distance: '1',
          size: 'large',
          arrow: true
        }),
        expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
      }],
      staticClass: "centralizado",
      staticStyle: {
        "width": "80px"
      },
      attrs: {
        "title": '<h5>Situação do título no Sapiens</h5>'
      }
    }, [_vm._v("Situação")]), _vm._v(" "), _c('th', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          inertia: true,
          arrow: true,
          animation: 'perspective',
          distance: '1',
          size: 'large',
          arrow: true
        }),
        expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
      }],
      staticClass: "centralizado",
      staticStyle: {
        "width": "130px"
      },
      attrs: {
        "title": '<h5>Número do título criado no Sapiens</h5>'
      }
    }, [_vm._v("Nº do documento")]), _vm._v(" "), _c('th', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          inertia: true,
          arrow: true,
          animation: 'perspective',
          distance: '1',
          size: 'large',
          arrow: true
        }),
        expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
      }],
      staticClass: "centralizado",
      staticStyle: {
        "width": "140px"
      },
      attrs: {
        "title": '<h5>Classificação do acerto se veio de um cancelamento de nota fiscal de entrada no Sapiens ou de título no contas a receber</h5>'
      }
    }, [_vm._v("Origem do acerto")]), _vm._v(" "), _c('th', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          inertia: true,
          arrow: true,
          animation: 'perspective',
          distance: '1',
          size: 'large',
          arrow: true
        }),
        expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
      }],
      staticClass: "centralizado",
      staticStyle: {
        "width": "100px"
      },
      attrs: {
        "title": '<h5>Valor do título no Sapiens</h5>'
      }
    }, [_vm._v("Valor")]), _vm._v(" "), _c('th', {
      staticClass: "centralizado",
      staticStyle: {
        "width": "180px"
      }
    }, [_c('i', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          inertia: true,
          arrow: true,
          animation: 'perspective',
          distance: '1',
          size: 'large',
          arrow: true
        }),
        expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
      }],
      staticClass: "fa fa-question-circle",
      attrs: {
        "aria-hidden": "true",
        "title": '<h5>Aqui constam os títulos de acertos registrados no Sapiens<br/><br/>O botão de Recomposição de saldo de itens permitirá acrescebtar saldo nos itens escolhidos sem alterar seu orçamento<br/> O botão de Cancelamento de processo de NF cancelará o ID da solicitação no SGP correspondente ao título cancelado no Sapiens.<br/>O botão de visualiar permite saber para quais itens foi a recomposiação do saldo se houver<br/>Este é um formulário dinâmico que sempre lê o Sapiens e as alterações registradas aqui <b>somente afetam o SGP</b></h5>'
      }
    })])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm._.groupBy(recurso, 'numeroContaFinanceira')), function(conta, numeroConta) {
      return [_c('tr', {
        staticClass: "atividade"
      }, [_c('td', {
        staticClass: "esquerda celula b1 b3 b4",
        attrs: {
          "colspan": "5"
        }
      }, [_vm._v(_vm._s(_vm._.first(conta)['numeroContaFinanceira']) + " / " + _vm._s(_vm._.first(conta)['nomeContaFinanceira']))]), _vm._v(" "), _c('td', {
        staticClass: "centralizado celula b1 b3 b2"
      }, [_vm._v(_vm._s(_vm._f("real")(_vm._.sumBy(conta, function(c) {
        return parseFloat(c.valor)
      }))))]), _vm._v(" "), _c('td', {
        staticClass: "centralizado celula b1 b3 b2"
      }, [_vm._v(" ")])]), _vm._v(" "), _vm._l((conta), function(titulo, tituloIndex) {
        return [_c('tr', [_c('td', {
          staticClass: "centralizado celula b3 b4"
        }, [_c('span', {
          directives: [{
            name: "tippy",
            rawName: "v-tippy",
            value: ({
              inertia: true,
              arrow: true,
              animation: 'perspective',
              distance: '1',
              size: 'large',
              arrow: true
            }),
            expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
          }],
          attrs: {
            "title": '<h5>Data de Entrada do título no Sapiens</h5>'
          }
        }, [_vm._v("\n                              " + _vm._s(_vm._f("moment")(titulo.dataEntrada, "L")) + "\n                            ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
          directives: [{
            name: "tippy",
            rawName: "v-tippy",
            value: ({
              inertia: true,
              arrow: true,
              animation: 'perspective',
              distance: '1',
              size: 'large',
              arrow: true
            }),
            expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
          }],
          attrs: {
            "title": '<h5>Data de Pagamento</h5>'
          }
        }, [_vm._v("\n                              " + _vm._s(_vm._f("moment")(titulo.dataPagamento, "L")) + "\n                            ")])]), _vm._v(" "), _c('td', {
          staticClass: "celula b3 b4"
        }, [_c('strong', [_vm._v(_vm._s(titulo.codigoClienteFornecedor) + "  " + _vm._s(titulo.nomeClienteFornecedor))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(titulo.observacao))])]), _vm._v(" "), _c('td', {
          staticClass: "centralizado celula b3 b4"
        }, [_c('span', [_vm._v(_vm._s(titulo.situacaoTitulo))])]), _vm._v(" "), _c('td', {
          staticClass: "centralizado celula b3 b4"
        }, [_c('span', [_vm._v("\n                            " + _vm._s(titulo.numeroTitulo)), _c('br'), _vm._v("\n                            " + _vm._s(titulo.tipoTitulo) + "\n                          ")])]), _vm._v(" "), _c('td', {
          staticClass: "centralizado celula b3 b4"
        }, [_c('span', [_vm._v(_vm._s(titulo.origemAcerto))])]), _vm._v(" "), _c('td', {
          staticClass: "centralizado celula b3 b4"
        }, [_c('span', [_vm._v(_vm._s(_vm._f("real")(titulo.valor)))])]), _vm._v(" "), _c('td', {
          staticClass: "centralizado celula b2 b3 b4"
        }, [(!_vm.mostrarListaItens) ? _c('span', [(_vm.formEditavel) ? _c('span', [(titulo.origemAcerto === 'Título - Contas a Receber') ? _c('span', [(_vm._.find(_vm._.get(titulo, 'processo.documentosliberacao[0].itens_liberados'), ['tipo', 'BASE'])) ? _c('span', [_c('g-button-ujarak', {
          attrs: {
            "color": "success",
            "size": "button--size-ss"
          },
          nativeOn: {
            "click": function($event) {
              return _vm.visualizaRecomposicaoSaldos(titulo)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-search"
        }), _vm._v(" Visualizar")])], 1) : _c('span', [_c('g-button-ujarak', {
          attrs: {
            "color": "primary",
            "size": "button--size-ss"
          },
          nativeOn: {
            "click": function($event) {
              return _vm.recomporSaldos(titulo)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-dollar"
        }), _vm._v(" "), _c('i', {
          staticClass: "fa fa-level-up",
          staticStyle: {
            "margin-left": "-2px"
          }
        }), _vm._v(" Recompor saldos")])], 1)]) : (titulo.origemAcerto === 'Cancelamento NF - Contas a Pagar\'') ? _c('span', [_c('g-button-ujarak', {
          attrs: {
            "color": "primary",
            "size": "button--size-ss"
          },
          nativeOn: {
            "click": function($event) {
              return _vm.cancelarSolicitacao(titulo)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-ban",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Cancelar solicitação")])], 1) : _vm._e()]) : _c('span', [(_vm._.find(_vm._.get(titulo, 'processo.documentosliberacao[0].itens_liberados'), ['tipo', 'BASE'])) ? _c('span', [(titulo.origemAcerto === 'Título - Contas a Receber') ? _c('g-button-ujarak', {
          attrs: {
            "color": "success",
            "size": "button--size-ss"
          },
          nativeOn: {
            "click": function($event) {
              return _vm.visualizaRecomposicaoSaldos(titulo)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-search"
        }), _vm._v(" Visualizar")]) : _vm._e()], 1) : _c('span', [_vm._v(" ")])])]) : _vm._e()])]), _vm._v(" "), (_vm.mostrarListaItens && _vm.acertoEdicao.chave === titulo.chave) ? _c('tr', [_c('td', {
          attrs: {
            "colspan": "7"
          }
        }, [_c('div', {
          staticClass: "quadroEdicaoItem",
          staticStyle: {
            "padding": "10px"
          }
        }, [_c('div', {
          staticClass: "form-group"
        }, [_c('label', {
          staticClass: "control-label col-md-12",
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("Itens com a mesma conta financeira do acerto:")]), _vm._v(" "), _c('div', [_c('div', {
          staticClass: "col-md-12"
        }, [_c('table', {
          staticClass: "table table-condensed table-bordered table-hover"
        }, [_c('thead', [_c('tr', {
          staticClass: "cabecalho"
        }, [_c('th', {
          attrs: {
            "colspan": "2"
          }
        }, [_vm._v(" ")]), _vm._v(" "), _c('th', {
          directives: [{
            name: "tippy",
            rawName: "v-tippy",
            value: ({
              inertia: true,
              arrow: true,
              animation: 'perspective',
              distance: '1',
              size: 'large',
              arrow: true
            }),
            expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
          }],
          staticClass: "centralizado",
          attrs: {
            "colspan": "2",
            "title": '<h5>Valor total contratado no projeto por Atividade e Item</h5>'
          }
        }, [_vm._v("\n                                      Orçado\n                                    ")]), _vm._v(" "), _c('th', {
          directives: [{
            name: "tippy",
            rawName: "v-tippy",
            value: ({
              inertia: true,
              arrow: true,
              animation: 'perspective',
              distance: '1',
              size: 'large',
              arrow: true
            }),
            expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
          }],
          staticClass: "centralizado",
          attrs: {
            "rowspan": "2",
            "title": '<h5>Valor para recomposição do saldo do item</h5>'
          }
        }, [_vm._v("\n                                      Recomposição\n                                    ")]), _vm._v(" "), _c('th', {
          directives: [{
            name: "tippy",
            rawName: "v-tippy",
            value: ({
              inertia: true,
              arrow: true,
              animation: 'perspective',
              distance: '1',
              size: 'large',
              arrow: true
            }),
            expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
          }],
          staticClass: "centralizado",
          attrs: {
            "colspan": "2",
            "title": '<h5>Saldo restante de cada Atividade e Item</h5>'
          }
        }, [_vm._v("\n                                      Saldo\n                                    ")]), _vm._v(" "), _c('th', {
          staticClass: "centralizado"
        }, [_vm._v(" ")])]), _vm._v(" "), _c('tr', {
          staticClass: "cabecalho"
        }, [_c('th', {
          attrs: {
            "colspan": "2"
          }
        }, [_vm._v("Atividade / Recursos (itens do cronograma)")]), _vm._v(" "), _c('th', {
          staticClass: "centralizado"
        }, [_vm._v("Qtde")]), _vm._v(" "), _c('th', {
          staticClass: "centralizado"
        }, [_vm._v("Valor")]), _vm._v(" "), _c('th', {
          staticClass: "centralizado"
        }, [_vm._v("Qtde")]), _vm._v(" "), _c('th', {
          staticClass: "centralizado"
        }, [_vm._v("Valor")]), _vm._v(" "), _c('th', {
          directives: [{
            name: "tippy",
            rawName: "v-tippy",
            value: ({
              inertia: true,
              arrow: true,
              animation: 'perspective',
              distance: '1',
              size: 'large',
              arrow: true
            }),
            expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
          }],
          staticClass: "centralizado",
          attrs: {
            "title": '<h5>Percentual aproximado já liberado<br/>Não considera Economicidade</h5>'
          }
        }, [_vm._v("\n                                      Atingimento\n                                    ")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.itensRecomposiacaoEdicao), function(item) {
          return [((_vm.acertoAcao === 'edicao') || (_vm.acertoAcao === 'visualizacao' && _vm._.has(item, 'Valor_solicitado') && item.Valor_solicitado !== 0)) ? _c('tr', [_c('td', {
            staticClass: "centralizado celula b3 b4"
          }, [(('' + item.origem).substring(0, 1) === '1') ? _c('span', [_vm._v("Fundação")]) : (('' + item.origem).substring(0, 1) === '2') ? _c('span', [_vm._v("Contrapartida")]) : (('' + item.origem).substring(0, 1) === '5') ? _c('span', [_vm._v("P.Estratégico")]) : _vm._e(), _vm._v(" "), (item.adiantavel === '1' || item.adiantavel === 1) ? _c('span', [_c('br'), _vm._v("Adiantável")]) : _vm._e()]), _vm._v(" "), _c('td', {
            staticClass: "celula b3 b4"
          }, [_c('div', {
            staticClass: "item"
          }, [_c('div', {
            staticClass: "item_despesa esquerda"
          }, [_vm._v("(" + _vm._s(_vm._.upperFirst(_vm._.lowerCase(item.item.ds_type))) + ")  " + _vm._s(item.item.ds_code + ' / ' + item.item.ds_description))]), _vm._v(" "), _c('div', {
            staticClass: "conta_financeira direita"
          }, [_vm._v(_vm._s(item.contaFinanceiraNumero) + " / " + _vm._s(item.contaFinanceiraDescricao))]), _vm._v(" "), _c('div', {
            staticClass: "observacao esquerda",
            domProps: {
              "innerHTML": _vm._s('<span class=id_item>#' + item.id + '</span>  ' + item.observacao + '</span>')
            }
          })])]), _vm._v(" "), _c('td', {
            directives: [{
              name: "tippy",
              rawName: "v-tippy",
              value: ({
                inertia: true,
                arrow: true,
                animation: 'perspective',
                distance: '1',
                size: 'large',
                arrow: true
              }),
              expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
            }],
            staticClass: "centralizado celula b3 b4",
            attrs: {
              "title": '<h5>' + (!_vm._.has(item, 'unidade_medida') || _vm._.isNull(item.unidade_medida) ? 'Sem unid. de medida' : (item.unidade_medida === 'Outros' && _vm._.has(item, 'medida_outros') && !_vm._.isNull(item.medida_outros) ? ('Outros:<br/>' + item.medida_outros) : item.unidade_medida)) + '</h5>'
            }
          }, [_vm._v("\n                                          " + _vm._s(item.quantidadeOrcado) + "\n                                        ")]), _vm._v(" "), _c('td', {
            staticClass: "centralizado celula b3"
          }, [_vm._v(_vm._s(_vm._f("decimal2")(item.valorOrcado)))]), _vm._v(" "), _c('td', {
            staticClass: "centralizado celula b3 valorRecomposicao"
          }, [_c('money', {
            staticClass: "form-control text-right valorSolicitacao",
            attrs: {
              "name": "valor a recompor",
              "type": "text",
              "disabled": _vm.acertoAcao === 'visualizacao'
            },
            nativeOn: {
              "keyup": function($event) {
                item.Valor_solicitado = _vm.limitaFaixaEntrada(item, 0, _vm.acertoEdicao.valor)
              }
            },
            model: {
              value: (item.Valor_solicitado),
              callback: function($$v) {
                _vm.$set(item, "Valor_solicitado", $$v)
              },
              expression: "item.Valor_solicitado"
            }
          })], 1), _vm._v(" "), _c('td', {
            directives: [{
              name: "tippy",
              rawName: "v-tippy",
              value: ({
                inertia: true,
                arrow: true,
                animation: 'perspective',
                distance: '1',
                size: 'large',
                arrow: true
              }),
              expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
            }],
            staticClass: "centralizado celula b3 b4",
            attrs: {
              "title": '<h5>' + (!_vm._.has(item, 'unidade_medida') || _vm._.isNull(item.unidade_medida) ? 'Sem unid. de medida' : (item.unidade_medida === 'Outros' && _vm._.has(item, 'medida_outros') && !_vm._.isNull(item.medida_outros) ? ('Outros:<br/>' + item.medida_outros) : item.unidade_medida)) + '</h5>'
            }
          }, [_vm._v("\n                                          " + _vm._s(item.quantidadeSaldo) + "\n                                        ")]), _vm._v(" "), _c('td', {
            staticClass: "centralizado celula b3"
          }, [_vm._v(_vm._s(_vm._f("decimal2")(item.valorSaldo + parseFloat(item.Valor_solicitado))))]), _vm._v(" "), _c('td', {
            staticClass: "centralizado celula b3 b2"
          }, [_vm._v("\n                                          " + _vm._s(_vm._f("percentage")(item.percAtingimento)) + "\n                                          "), (('' + item.economicidade) === '1') ? _c('i', {
            directives: [{
              name: "tippy",
              rawName: "v-tippy",
              value: ({
                inertia: true,
                arrow: true,
                animation: 'perspective',
                distance: '1',
                size: 'large',
                arrow: true
              }),
              expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
            }],
            staticClass: "fa fa-dollar economicidade",
            attrs: {
              "title": '<h5>Comprovado com Economicidade</h5>'
            }
          }) : _vm._e()])]) : _vm._e()]
        })], 2)])])])]), _vm._v(" "), (_vm.formEditavel) ? _c('div', {
          staticClass: "col-md-12 form-group required-field",
          class: {
            'has-error': _vm.errors.first('justificativa')
          }
        }, [_c('label', {
          staticClass: "control-label col-md-2"
        }, [_vm._v("Justificativa:")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-10"
        }, [_c('textarea', {
          directives: [{
            name: "resizable",
            rawName: "v-resizable"
          }, {
            name: "model",
            rawName: "v-model",
            value: (_vm.acertoEdicao.justificativa),
            expression: "acertoEdicao.justificativa"
          }, {
            name: "validate",
            rawName: "v-validate",
            value: ('required'),
            expression: "'required'"
          }],
          staticClass: "form-control",
          attrs: {
            "name": "justificativa",
            "placeholder": "Descreva justificativa para recomposição dos itens deste acerto",
            "rows": "3",
            "data-vv-as": "Justificativa",
            "disabled": _vm.acertoAcao === 'visualizacao'
          },
          domProps: {
            "value": (_vm.acertoEdicao.justificativa)
          },
          on: {
            "input": function($event) {
              if ($event.target.composing) { return; }
              _vm.$set(_vm.acertoEdicao, "justificativa", $event.target.value)
            }
          }
        }), _vm._v(" "), (_vm.errors.first('justificativa')) ? _c('span', {
          staticClass: "label label-danger"
        }, [_vm._v(" " + _vm._s(_vm.errors.first('justificativa')))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
          staticClass: "form-group"
        }, [_c('div', {
          staticClass: "col-md-10 col-md-offset-2"
        }, [(_vm.acertoAcao !== 'visualizacao') ? _c('button', {
          staticClass: "btn btn-confirm btn-flat",
          attrs: {
            "type": "button"
          },
          on: {
            "click": _vm.ok
          }
        }, [_c('i', {
          staticClass: "fa fa-check",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Ok")]) : _vm._e(), _vm._v(" "), _c('button', {
          staticClass: "btn btn-back btn-flat",
          attrs: {
            "type": "button"
          },
          on: {
            "~click": function($event) {
              return _vm.cancelar($event)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-times-circle",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Cancelar")])])])])])]) : _vm._e()]
      })]
    })], 2)]
  })], 2)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v("  Verificando se há acertos de devolução no Sapiens e atualizando SGP...")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c0f5a584!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/projetos/AcertosFinanceiros.vue
// module id = 1950
// module chunks = 2